import React, { useState, useEffect } from "react";
import { useCustomScreen } from "../Utils";
export default function RatesSection() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 767);
  const [isMediumScreen, setIsMediumScreen] = useState(
    window.innerWidth >= 768 && window.innerWidth <= 1023
  );
  const [isLargeScreen, setIsLargeScreen] = useState(
    window.innerWidth >= 1024 && window.innerWidth <= 1200
  );
  const [isXlScreen, setIsXlScreen] = useState(
    window.innerWidth > 1200 && window.innerWidth <= 1400
  );
  const [isXxlScreen, setIsXxlScreen] = useState(
    window.innerWidth > 1400 && window.innerWidth <= 2000
  );
  const [is4kScreen, setIs4kScreen] = useState(window.innerWidth > 2000);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 767);
      setIsMediumScreen(window.innerWidth >= 768 && window.innerWidth < 1024);
      setIsLargeScreen(window.innerWidth >= 1024 && window.innerWidth <= 1200);
      setIsXlScreen(window.innerWidth > 1200 && window.innerWidth <= 1400);
      setIsXxlScreen(window.innerWidth > 1400 && window.innerWidth <= 2000);
      setIs4kScreen(window.innerWidth > 2000);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { isIpadProPortrait } = useCustomScreen();

  return (
    <section
      id="low-rate"
      style={{
        minHeight: isSmallScreen ? "100vh" : "100vh",
      }}
      className="d-flex justify-content-center align-items-center"
    >
      <div className="p-3 d-flex flex-column justiy-content-center align-items-center">
        <header
          className="text-center "
          style={{
            paddingTop: isLargeScreen ? "2rem" : "",
            paddingLeft: isMediumScreen ? "5rem" : "",
            paddingBottom: is4kScreen ? "5rem" : "",
            marginBottom: is4kScreen
              ? "4rem"
              : isXxlScreen
              ? "3rem"
              : isXlScreen
              ? "3rem"
              : isLargeScreen
              ? "2rem"
              : isMediumScreen
              ? "2.5rem"
              : "",
          }}
        >
          <h1
            className="text-center"
            style={{
              fontWeight: "bold",
              fontSize: is4kScreen
                ? "5.3rem"
                : isXxlScreen
                ? "2.8rem"
                : isXlScreen
                ? "2.6rem"
                : isIpadProPortrait
                ? "3rem"
                : isLargeScreen
                ? "2.5rem"
                : isMediumScreen
                ? "2.4rem"
                : isSmallScreen
                ? "2rem"
                : "",
            }}
          >
            Low, flat rates
          </h1>
          <p
            style={{
              fontSize: "25px",
              color: "#4E585A",
              fontSize: is4kScreen
                ? "3rem"
                : isXxlScreen
                ? "1.8rem"
                : isXlScreen
                ? "1.6rem"
                : isIpadProPortrait
                ? "2rem"
                : isLargeScreen
                ? "1.3rem"
                : isMediumScreen
                ? "1.5rem"
                : isSmallScreen
                ? "1.3rem"
                : "",
            }}
          >
            No price variations based on size. <br />
            No special membership or subscriptions you won't fully use.
          </p>
        </header>

        {isSmallScreen ? (
          <>
            <div
              className="table-responsive m-3"
              style={{ overflowX: "hidden" }}
            >
              <table className="table text-center m-1">
                <th className="">
                  <h6
                    className="fw-bold"
                    style={{
                      color: "#4E585A",
                      minWidth: "150px",
                      fontSize: "1rem",
                    }}
                  >
                    BASIC
                  </h6>
                </th>
                <th className="">
                  <h6
                    className="fw-bold"
                    style={{
                      color: "#4E585A",
                      minWidth: "150px",
                      fontSize: "1rem",
                    }}
                  >
                    STANDARD
                  </h6>
                </th>
                <tbody>
                  <tr>
                    <td className="gray-box p-3 border-bottom-solid border-right-dashed">
                      <h5 className=" fw-bold" style={{ fontSize: "1rem" }}>
                        $20 USD
                      </h5>
                      <h6 style={{ fontSize: "0.9rem" }}> per Report</h6>
                    </td>
                    <td className="gray-box p-3 border-bottom-solid">
                      <h5 className="fw-bold" style={{ fontSize: "1rem" }}>
                        $30 USD
                      </h5>
                      <h6 style={{ fontSize: "0.9rem" }}> per Report</h6>
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="light-blue-box p-3 border-right-dashed"
                      style={{ padding: "0.4rem" }}
                    >
                      <h3 className="fw-bold" style={{ fontSize: "1rem" }}>
                        $180 USD
                      </h3>
                      <h4 style={{ fontSize: "0.9rem" }}> per 10 Pack</h4>
                    </td>
                    <td
                      className="light-blue-box p-3"
                      style={{ padding: "0.4rem" }}
                    >
                      <h3 className="fw-bold" style={{ fontSize: "1rem" }}>
                        $270 USD
                      </h3>
                      <h4 style={{ fontSize: "0.9rem" }}> per 10 Pack</h4>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div
              className="table-responsive m-3"
              style={{ overflowX: "hidden" }}
            >
              <table className="table text-center m-1">
                <th className="">
                  <h6
                    className="fw-bold"
                    style={{
                      color: "#4E585A",
                      minWidth: "150px",
                      fontSize: "1rem",
                    }}
                  >
                    COMPREHENSIVE
                  </h6>
                </th>
                <th className="">
                  <h6
                    className="fw-bold"
                    style={{
                      color: "#4E585A",
                      minWidth: "150px",
                      fontSize: "1rem",
                    }}
                  >
                    CLAIMS
                  </h6>
                </th>
                <tbody>
                  <tr>
                    <td className="gray-box p-3 border-right-dashed border-bottom-solid">
                      <h6 className="fw-bold" style={{ fontSize: "1rem" }}>
                        $45 USD
                      </h6>
                      <h6 style={{ fontSize: "0.9rem" }}>per Report</h6>
                    </td>
                    <td className="gray-box p-3 border-bottom-solid">
                      <h6 className="fw-bold" style={{ fontSize: "1rem" }}>
                        $35 USD
                      </h6>
                      <h6 style={{ fontSize: "0.9rem" }}> per Report</h6>
                    </td>
                  </tr>
                  <tr>
                    <td className="light-blue-box py-3 border-right-dashed">
                      <h6 className="fw-bold" style={{ fontSize: "1rem" }}>
                        $405 USD
                      </h6>
                      <h4 style={{ fontSize: "0.9rem" }}> per 10 Pack</h4>
                    </td>
                    <td className="light-blue-box py-3 ">
                      <h3 className="fw-bold" style={{ fontSize: "1rem" }}>
                        $315 USD
                      </h3>
                      <h4 style={{ fontSize: "0.9rem" }}> per 10 Pack</h4>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="text-center mt-4">
              <h5 style={{ color: "#4E585A", fontSize: "15px" }}>
                <b>In a hurry?</b> Skip to the front of the line with
              </h5>
              <h5 style={{ color: "#57C0D1", fontSize: "0.8rem" }}>
                <b>Rush Delivery : $15/report </b>
              </h5>
            </div>
          </>
        ) : (
          <div
            style={{
              width: "100%",
              paddingLeft: isMediumScreen ? "8rem" : "",
              paddingRight: isSmallScreen
                ? ""
                : isIpadProPortrait
                ? "2rem"
                : isLargeScreen
                ? "5rem"
                : "10em",
              // paddingTop: is4kScreen ? "4rem" :isXxlScreen? "" : isXlScreen ? "" : isLargeScreen ? "" : "",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
            className="table-responsive text-center "
          >
            <table className="text-center p-2 ">
              <thead>
                <tr>
                  <th className="py-3 pl-2 " style={{ minWidth: "150px" }}>
                    &nbsp;
                  </th>
                  <th
                    className="py-3"
                    style={{
                      width: is4kScreen
                        ? "8rem"
                        : isLargeScreen
                        ? "7rem"
                        : "165px",
                      minWidth: is4kScreen
                        ? "24rem"
                        : isXxlScreen
                        ? "13rem"
                        : isXlScreen
                        ? "12rem"
                        : isIpadProPortrait
                        ? "12.5rem"
                        : isLargeScreen
                        ? "12rem"
                        : "150px",
                    }}
                  >
                    <h2
                      className=" fw-bold"
                      style={{
                        color: "#4E585A",
                        fontSize: is4kScreen
                          ? "2.3rem"
                          : isXxlScreen
                          ? "1.3rem"
                          : isXlScreen
                          ? "1.2rem"
                          : isIpadProPortrait
                          ? "1.6rem"
                          : isLargeScreen
                          ? "1.1rem"
                          : isMediumScreen
                          ? "1.2rem"
                          : isSmallScreen
                          ? ""
                          : "",
                      }}
                    >
                      BASIC
                    </h2>
                  </th>
                  <th
                    className="py-3"
                    style={{
                      minWidth: is4kScreen
                        ? "24rem"
                        : isXxlScreen
                        ? "13rem"
                        : isXlScreen
                        ? "12rem"
                        : isIpadProPortrait
                        ? "12.5rem"
                        : isLargeScreen
                        ? "12rem"
                        : "150px",
                    }}
                  >
                    <h2
                      className="fw-bold"
                      style={{
                        color: "#4E585A",
                        fontSize: is4kScreen
                          ? "2.3rem"
                          : isXxlScreen
                          ? "1.3rem"
                          : isXlScreen
                          ? "1.2rem"
                          : isIpadProPortrait
                          ? "1.6rem"
                          : isLargeScreen
                          ? "1.1rem"
                          : isMediumScreen
                          ? "1.2rem"
                          : "",
                      }}
                    >
                      STANDARD
                    </h2>
                  </th>
                  <th
                    className="py-3"
                    style={{
                      width: is4kScreen
                        ? "8rem"
                        : isXxlScreen
                        ? ""
                        : isXlScreen
                        ? ""
                        : isLargeScreen
                        ? "7rem"
                        : "165px",
                      minWidth: is4kScreen
                        ? "24rem"
                        : isXxlScreen
                        ? "13rem"
                        : isXlScreen
                        ? "12rem"
                        : isIpadProPortrait
                        ? "12.5rem"
                        : isLargeScreen
                        ? "12rem"
                        : "150px",
                    }}
                  >
                    <h2
                      className="fw-bold"
                      style={{
                        color: "#4E585A",
                        fontSize: is4kScreen
                          ? "2.3rem"
                          : isXxlScreen
                          ? "1.3rem"
                          : isXlScreen
                          ? "1.2rem"
                          : isIpadProPortrait
                          ? "1.6rem"
                          : isLargeScreen
                          ? "1.1rem"
                          : isMediumScreen
                          ? "1.2rem"
                          : "",
                      }}
                    >
                      COMPREHENSIVE
                    </h2>
                  </th>
                  <th
                    className="py-3"
                    style={{
                      minWidth: is4kScreen
                        ? "24rem"
                        : isXxlScreen
                        ? "13rem"
                        : isXlScreen
                        ? "12rem"
                        : isIpadProPortrait
                        ? "12.5rem"
                        : isLargeScreen
                        ? "12rem"
                        : "150px",
                    }}
                  >
                    <h2
                      className="fw-bold"
                      style={{
                        color: "#4E585A",
                        fontSize: is4kScreen
                          ? "2.3rem"
                          : isXxlScreen
                          ? "1.3rem"
                          : isXlScreen
                          ? "1.2rem"
                          : isIpadProPortrait
                          ? "1.6rem"
                          : isLargeScreen
                          ? "1.1rem"
                          : isMediumScreen
                          ? "1.2rem"
                          : "",
                      }}
                    >
                      CLAIMS
                    </h2>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="py-4 pr-2">
                    <h1
                      className=" fw-bold text-muted p-2"
                      style={{
                        color: "#4E585A",
                        fontSize: is4kScreen
                          ? "2.5rem"
                          : isXxlScreen
                          ? "1.8rem"
                          : isXlScreen
                          ? "1.5rem"
                          : isIpadProPortrait
                          ? "1.6rem"
                          : isLargeScreen
                          ? "1.3rem"
                          : isMediumScreen
                          ? "1.2rem"
                          : "",
                      }}
                    >
                      Pay as <br /> you go
                    </h1>
                  </td>
                  <td className="gray-box p-4 border-right-dashed border-bottom-solid">
                    <h3
                      className="fw-bold "
                      style={{
                        fontSize: is4kScreen
                          ? "2.5rem"
                          : isXxlScreen
                          ? "1.5rem"
                          : isXlScreen
                          ? "1.4rem"
                          : isIpadProPortrait
                          ? "1.8rem"
                          : isLargeScreen
                          ? "1.3rem"
                          : "1.1rem",
                      }}
                    >
                      $20 USD
                    </h3>
                    <h4
                      className=""
                      style={{
                        fontSize: is4kScreen
                          ? "2.1rem"
                          : isXxlScreen
                          ? "1.1rem"
                          : isXlScreen
                          ? "1.1rem"
                          : isIpadProPortrait
                          ? "1.6rem"
                          : isLargeScreen
                          ? "0.9rem"
                          : "1rem",
                      }}
                    >
                      per Report
                    </h4>
                  </td>
                  <td className="gray-box p-3 border-right-dashed border-bottom-solid">
                    <h3
                      className="fw-bold"
                      style={{
                        fontSize: is4kScreen
                          ? "2.5rem"
                          : isXxlScreen
                          ? "1.5rem"
                          : isXlScreen
                          ? "1.4rem"
                          : isIpadProPortrait
                          ? "1.8rem"
                          : isLargeScreen
                          ? "1.3rem"
                          : "1rem",
                      }}
                    >
                      $30 USD
                    </h3>
                    <h4
                      className=""
                      style={{
                        fontSize: is4kScreen
                          ? "2.1rem"
                          : isXxlScreen
                          ? "1.1rem"
                          : isXlScreen
                          ? "1.1rem"
                          : isIpadProPortrait
                          ? "1.6rem"
                          : isLargeScreen
                          ? "0.9rem"
                          : "1rem",
                      }}
                    >
                      per Report
                    </h4>
                  </td>
                  <td className="gray-box p-3 border-right-dashed border-bottom-solid">
                    <h3
                      className="fw-bold"
                      style={{
                        fontSize: is4kScreen
                          ? "2.5rem"
                          : isXxlScreen
                          ? "1.5rem"
                          : isXlScreen
                          ? "1.4rem"
                          : isIpadProPortrait
                          ? "1.8rem"
                          : isLargeScreen
                          ? "1.3rem"
                          : "1rem",
                      }}
                    >
                      $45 USD
                    </h3>
                    <h4
                      className=""
                      style={{
                        fontSize: is4kScreen
                          ? "2.1rem"
                          : isXxlScreen
                          ? "1.1rem"
                          : isXlScreen
                          ? "1.1rem"
                          : isIpadProPortrait
                          ? "1.6rem"
                          : isLargeScreen
                          ? "0.9rem"
                          : "1rem",
                      }}
                    >
                      per Report
                    </h4>
                  </td>
                  <td className="gray-box p-3 border-bottom-solid">
                    <h3
                      className="fw-bold"
                      style={{
                        fontSize: is4kScreen
                          ? "2.5rem"
                          : isXxlScreen
                          ? "1.5rem"
                          : isXlScreen
                          ? "1.4rem"
                          : isIpadProPortrait
                          ? "1.8rem"
                          : isLargeScreen
                          ? "1.3rem"
                          : "1rem",
                      }}
                    >
                      $35 USD
                    </h3>
                    <h4
                      className=""
                      style={{
                        fontSize: is4kScreen
                          ? "2.1rem"
                          : isXxlScreen
                          ? "1.1rem"
                          : isXlScreen
                          ? "1.1rem"
                          : isIpadProPortrait
                          ? "1.6rem"
                          : isLargeScreen
                          ? "0.9rem"
                          : "1rem",
                      }}
                    >
                      per Report
                    </h4>
                  </td>
                </tr>
                <tr>
                  <td className="py-4">
                    <h1
                      className={`fw-bold text-muted ${
                        isLargeScreen ? "" : isMediumScreen ? "" : "p-3"
                      }`}
                      style={{
                        color: "#4E585A",
                        fontSize: is4kScreen
                          ? "2.5rem"
                          : isXxlScreen
                          ? "1.8rem"
                          : isXlScreen
                          ? "1.5rem"
                          : isIpadProPortrait
                          ? "1.6rem"
                          : isLargeScreen
                          ? "1.3rem"
                          : isMediumScreen
                          ? "1.2rem"
                          : "",
                      }}
                    >
                      Pre-order <br /> for savings
                    </h1>
                  </td>
                  <td
                    className={`light-blue-box py-3 border-right-dashed ${
                      isLargeScreen ? "" : "p-3"
                    } `}
                  >
                    <h3
                      className="fw-bold"
                      style={{
                        fontSize: is4kScreen
                          ? "2.5rem"
                          : isXxlScreen
                          ? "1.5rem"
                          : isXlScreen
                          ? "1.4rem"
                          : isIpadProPortrait
                          ? "1.8rem"
                          : isLargeScreen
                          ? "1.3rem"
                          : "1rem",
                      }}
                    >
                      $180 USD
                    </h3>
                    <h4
                      className=""
                      style={{
                        fontSize: is4kScreen
                          ? "2.1rem"
                          : isXxlScreen
                          ? "1.1rem"
                          : isXlScreen
                          ? "1.1rem"
                          : isIpadProPortrait
                          ? "1.5rem"
                          : isLargeScreen
                          ? "0.9rem"
                          : "1rem",
                      }}
                    >
                      per 10 Pack
                    </h4>
                    <p
                      style={{
                        fontSize: is4kScreen
                          ? "2rem"
                          : isXxlScreen
                          ? "1rem"
                          : isXlScreen
                          ? "1rem"
                          : isIpadProPortrait
                          ? "1.5rem"
                          : isLargeScreen
                          ? "0.9rem"
                          : "",
                      }}
                    >
                      10% savings
                    </p>
                  </td>
                  <td className="light-blue-box py-3 border-right-dashed p-3">
                    <h3
                      className="fw-bold"
                      style={{
                        fontSize: is4kScreen
                          ? "2.5rem"
                          : isXxlScreen
                          ? "1.5rem"
                          : isXlScreen
                          ? "1.4rem"
                          : isIpadProPortrait
                          ? "1.8rem"
                          : isLargeScreen
                          ? "1.3rem"
                          : "1rem",
                      }}
                    >
                      $270 USD
                    </h3>
                    <h4
                      className=""
                      style={{
                        fontSize: is4kScreen
                          ? "2.1rem"
                          : isXxlScreen
                          ? "1.1rem"
                          : isXlScreen
                          ? "1.1rem"
                          : isIpadProPortrait
                          ? "1.5rem"
                          : isLargeScreen
                          ? "0.9rem"
                          : "1rem",
                      }}
                    >
                      per 10 Pack
                    </h4>
                    <p
                      style={{
                        fontSize: is4kScreen
                          ? "2rem"
                          : isXxlScreen
                          ? "1rem"
                          : isXlScreen
                          ? "1rem"
                          : isIpadProPortrait
                          ? "1.5rem"
                          : isLargeScreen
                          ? "0.9rem"
                          : "",
                      }}
                    >
                      10% savings
                    </p>
                  </td>
                  <td className="light-blue-box py-3 border-right-dashed p-3">
                    <h3
                      className=" fw-bold"
                      style={{
                        fontSize: is4kScreen
                          ? "2.5rem"
                          : isXxlScreen
                          ? "1.5rem"
                          : isXlScreen
                          ? "1.4rem"
                          : isIpadProPortrait
                          ? "1.8rem"
                          : isLargeScreen
                          ? "1.3rem"
                          : "1rem",
                      }}
                    >
                      $405 USD
                    </h3>
                    <h4
                      className=""
                      style={{
                        fontSize: is4kScreen
                          ? "2.1rem"
                          : isXxlScreen
                          ? "1.1rem"
                          : isXlScreen
                          ? "1.1rem"
                          : isIpadProPortrait
                          ? "1.5rem"
                          : isLargeScreen
                          ? "0.9rem"
                          : "1rem",
                      }}
                    >
                      per 10 Pack
                    </h4>
                    <p
                      style={{
                        fontSize: is4kScreen
                          ? "2rem"
                          : isXxlScreen
                          ? "1rem"
                          : isXlScreen
                          ? "1rem"
                          : isIpadProPortrait
                          ? "1.5rem"
                          : isLargeScreen
                          ? "0.9rem"
                          : "",
                      }}
                    >
                      10% savings
                    </p>
                  </td>
                  <td className="light-blue-box py-3 p-3">
                    <h3
                      className="fw-bold"
                      style={{
                        fontSize: is4kScreen
                          ? "2.5rem"
                          : isXxlScreen
                          ? "1.5rem"
                          : isXlScreen
                          ? "1.4rem"
                          : isIpadProPortrait
                          ? "1.8rem"
                          : isLargeScreen
                          ? "1.3rem"
                          : "1rem",
                      }}
                    >
                      $315 USD
                    </h3>
                    <h4
                      className=""
                      style={{
                        fontSize: is4kScreen
                          ? "2.1rem"
                          : isXxlScreen
                          ? "1.1rem"
                          : isXlScreen
                          ? "1.1rem"
                          : isIpadProPortrait
                          ? "1.5rem"
                          : isLargeScreen
                          ? "0.9rem"
                          : "1rem",
                      }}
                    >
                      per 10 Pack
                    </h4>
                    <p
                      style={{
                        fontSize: is4kScreen
                          ? "2rem"
                          : isXxlScreen
                          ? "1rem"
                          : isXlScreen
                          ? "1rem"
                          : isIpadProPortrait
                          ? "1.5rem"
                          : isLargeScreen
                          ? "0.9rem"
                          : "",
                      }}
                    >
                      10% savings
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              className="text-center  mt-4"
              style={{
                paddingBottom: isLargeScreen ? "2rem" : "",
                paddingLeft: isSmallScreen
                  ? ""
                  : is4kScreen
                  ? "19rem"
                  : isXxlScreen
                  ? "14rem"
                  : isXlScreen
                  ? " 13rem"
                  : isIpadProPortrait
                  ? " 6rem"
                  : isLargeScreen
                  ? "5rem"
                  : "5rem",
              }}
            >
              <h5
                style={{
                  color: "#4E585A",
                  fontSize: is4kScreen
                    ? "2.6rem"
                    : isXxlScreen
                    ? "1.3rem"
                    : isXlScreen
                    ? "1.2rem"
                    : isIpadProPortrait
                    ? "1.6rem"
                    : isLargeScreen
                    ? "1.2rem"
                    : isMediumScreen
                    ? "1.3rem"
                    : isSmallScreen
                    ? "1.3rem"
                    : "1rem",
                }}
              >
                <b>In a hurry?</b> Skip to the front of the line with
              </h5>
              <h5
                className=""
                style={{
                  color: "#57C0D1",
                  fontSize: is4kScreen
                    ? "2.6rem"
                    : isXxlScreen
                    ? "1.3rem"
                    : isXlScreen
                    ? "1.2rem"
                    : isIpadProPortrait
                    ? "1.6rem"
                    : isLargeScreen
                    ? "1.2rem"
                    : isMediumScreen
                    ? "1.3rem"
                    : isSmallScreen
                    ? "0.8rem !important"
                    : "1rem",
                }}
              >
                <b>Rush Delivery : $15 USD/report </b>
              </h5>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

{
  /* <div className=" d-block bg-danger d-md-none text-center d-flex flex-column justify-content-center align-items-center">
<table className=" text-center">
  <thead>
    <tr>
      <th className="py-3 d-none d-md-block">&nbsp;</th>
      <th className="py-3">
        <h2 className="fs-5 fw-bold" style={{ color: "#4E585A" }}>
          BASIC
        </h2>
      </th>
      <th className="py-3">
        <h2 className="fs-5 fw-bold" style={{ color: "#4E585A" }}>
          STANDARD
        </h2>
      </th>
      <th className="py-3">
        <h2 className="fs-5 fw-bold" style={{ color: "#4E585A" }}>
          EXPANDED
        </h2>
      </th> 
       <th className="py-3">
        <h2 className="fs-5 fw-bold" style={{ color: "#4E585A" }}>
          CLAIMS
        </h2>
      </th>
      <th className="py-3">&nbsp;</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td className="py-4 d-none d-md-block pr-2">
        <h1 className="fs-5 fw-bold text-muted ">
          Pay as <br /> you go
        </h1>
      </td>
      <td className="gray-box p-3 border-right-dashed border-bottom-solid">
        <h3 className="fs-4 fw-bold">$20</h3>
        <h4 className="fs-6">per Report</h4>
      </td>
      <td className="gray-box p-3 border-right-dashed border-bottom-solid">
        <h3 className="fs-4 fw-bold">$35</h3>
        <h4 className="fs-6">per Report</h4>
      </td>
      <td className="gray-box p-3 border-right-dashed border-bottom-solid">
        <h3 className="fs-4 fw-bold">$45</h3>
        <h4 className="fs-6">per Report</h4>
      </td>
      <td className="gray-box p-3 border-bottom-solid">
        <h3 className="fs-4 fw-bold">$38</h3>
        <h4 className="fs-6">per Report</h4>
      </td>
      <td className="py-4">&nbsp;</td>
    </tr>
    <tr>
      <td
        className="py-4 d-none d-md-block"
        style={{ paddingRight: "10px" }}
      >
        <h1 className="fs-5 fw-bold text-muted pl-2">
          Pre-order <br /> for savings
        </h1>
      </td>
      <td className="light-blue-box py-3 border-right-dashed p-3">
        <h3 className="fs-4 fw-bold">$180</h3>
        <h4 className="fs-6">per 10 Pack</h4>
        <h4 className="fs-6 mt-2 fst-italic">10% saving</h4>
      </td>
      <td className="light-blue-box py-3 border-right-dashed p-3">
        <h3 className="fs-4 fw-bold">$297</h3>
        <h4 className="fs-6">per 10 Pack</h4>
        <h4 className="fs-6 mt-2 fst-italic">10% saving</h4>
      </td>
      <td className="light-blue-box py-3 border-right-dashed p-3">
        <h3 className="fs-4 fw-bold">$405</h3>
        <h4 className="fs-6">per 10 Pack</h4>
        <h4 className="fs-6 mt-2 fst-italic">10% saving</h4>
      </td>
      <td className="light-blue-box py-3 p-3">
        <h3 className="fs-4 fw-bold">$342</h3>
        <h4 className="fs-6">per 10 Pack</h4>
        <h4 className="fs-6 mt-2 fst-italic">10% saving</h4>
      </td>
      <td className="py-4">&nbsp;</td>
    </tr>
  </tbody>
  <thead className="">
    <tr>
      <th className="py-3 d-none d-md-block">&nbsp;</th>

      <th className="py-3">
        <h2 className="fs-5 fw-bold" style={{ color: "#4E585A" }}>
          EXPANDED
        </h2>
      </th>
      <th className="py-3">
        <h2 className="fs-5 fw-bold" style={{ color: "#4E585A" }}>
          CLAIMS
        </h2>
      </th>
      <th className="py-3">&nbsp;</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td className="py-4 d-none d-md-block pr-2">
        <h1 className="fs-5 fw-bold text-muted ">
          Pay as <br /> you go
        </h1>
      </td>

      <td className="gray-box p-3 border-right-dashed border-bottom-solid">
        <h3 className="fs-4 fw-bold">$45</h3>
        <h4 className="fs-6">per Report</h4>
      </td>
      <td className="gray-box p-3 border-bottom-solid">
        <h3 className="fs-4 fw-bold">$38</h3>
        <h4 className="fs-6">per Report</h4>
      </td>
      <td className="py-4">&nbsp;</td>
    </tr>
    <tr>
      <td
        className="py-4 d-none d-md-block"
        style={{ paddingRight: "10px" }}
      >
        <h1 className="fs-5 fw-bold text-muted pl-2">
          Pre-order <br /> for savings
        </h1>
      </td>

      <td className="light-blue-box py-3 border-right-dashed p-3">
        <h3 className="fs-4 fw-bold">$405</h3>
        <h4 className="fs-6">per 10 Pack</h4>
        <h4 className="fs-6 mt-2 fst-italic">10% saving</h4>
      </td>
      <td className="light-blue-box py-3 p-3">
        <h3 className="fs-4 fw-bold">$342</h3>
        <h4 className="fs-6">per 10 Pack</h4>
        <h4 className="fs-6 mt-2 fst-italic">10% saving</h4>
      </td>
      <td className="py-4">&nbsp;</td>
    </tr>
  </tbody>
</table>
</div> */
}

{
  /* <div className="table-responsive" style={{ overflowX: "auto" }}>
          <table width="" border="0" cellSpacing="20" cellPadding="20">
            <tbody>
              <tr>
                <td width="300" height="75">
                  &nbsp;
                </td>
                <td width="50" valign="bottom" className="text-center">
                  <h2
                    style={{
                      fontSize: "25px",
                      fontWeight: "bold",
                      color: "#4E585A",
                    }}
                  >
                    STANDARD
                  </h2>
                </td>
                <td width="300" valign="bottom" className="text-center">
                  <h2
                    style={{
                      fontSize: "25px",
                      fontWeight: "bold",
                      color: "#4E585A",
                    }}
                  >
                    EXPANDED
                  </h2>
                </td>
                <td width="300" valign="bottom" className="text-center">
                  <h2
                    style={{
                      fontSize: "25px",
                      fontWeight: "bold",
                      color: "#4E585A",
                    }}
                  >
                    CLAIMS
                  </h2>
                </td>
                <td width="300">&nbsp;</td>
              </tr>
              <tr>
                <td className="text-center">
                  <h1 style={{ fontSize: "30px" }}>
                    <span style={{ lineHeight: "15px", color: "#4E585A" }}>
                      Pay as
                      <br />
                      you go
                    </span>
                  </h1>
                </td>
                <td
                  height="150"
                  className="text-center gray-box py-3 border-right-dashed border-bottom-solid"
                >
                  <h3 style={{ fontSize: "25px", fontWeight: "bold" }}>$30</h3>
                  <h4 style={{ fontSize: "20px" }}>per Report</h4>
                </td>
                <td className="text-center gray-box py-3 border-right-dashed border-bottom-solid">
                  <h3 style={{ fontSize: "25px", fontWeight: "bold" }}>$45</h3>
                  <h4 style={{ fontSize: "20px" }}>per Report</h4>
                </td>
                <td className="text-center gray-box py-3 border-bottom-solid">
                  <h3 style={{ fontSize: "25px", fontWeight: "bold" }}>$35</h3>
                  <h4 style={{ fontSize: "20px" }}>per Report</h4>
                </td>
                <td className="text-center">
                  <h1 style={{ fontSize: "30px" }}>&nbsp;</h1>
                </td>
              </tr>
              <tr>
                <td className="text-center">
                  <h1 style={{ fontSize: "30px" }}>
                    <span style={{ lineHeight: "15px", color: "#4E585A" }}>
                      Pre-order
                      <br />
                      for savings
                    </span>
                  </h1>
                </td>
                <td
                  height="150"
                  className="text-center light-blue-box py-3 border-right-dashed"
                >
                  <h3 style={{ fontSize: "25px", fontWeight: "bold" }}>$250</h3>
                  <h4 style={{ fontSize: "20px" }}>per 10 Pack</h4>
                  <h4
                    style={{
                      fontSize: "15px",
                      marginTop: "20px",
                      fontStyle: "italic",
                    }}
                  >
                    Savings of $50
                  </h4>
                </td>
                <td className="text-center light-blue-box py-3 border-right-dashed">
                  <h3 style={{ fontSize: "25px", fontWeight: "bold" }}>$400</h3>
                  <h4 style={{ fontSize: "20px" }}>per 10 Pack</h4>
                  <h4
                    style={{
                      fontSize: "15px",
                      marginTop: "20px",
                      fontStyle: "italic",
                    }}
                  >
                    Savings of $50
                  </h4>
                </td>
                <td className="text-center light-blue-box py-3">
                  <h3 style={{ fontSize: "25px", fontWeight: "bold" }}>$300</h3>
                  <h4 style={{ fontSize: "20px" }}>per 10 Pack</h4>
                  <h4
                    style={{
                      fontSize: "15px",
                      marginTop: "20px",
                      fontStyle: "italic",
                    }}
                  >
                    Savings of $50
                  </h4>
                </td>
              </tr>
            </tbody>
          </table>
        </div> */
}
